import Swal from 'sweetalert2'

export function useConfirmation() {
	return Swal.fire({
		icon: 'success',
		title: 'OK',
		timer: 600,
		showConfirmButton: false,
		customClass: {
			container: 'themed',
		},
		// toast: true,
		// position: 'top'
	})
}
